import React from 'react';

/**
 * Shared heart icon for favorite controls and favorite navigation states.
 *
 * @param {Object} props component props
 * @param {string} [props.className] additional CSS class
 * @param {number|string} [props.size=24] rendered width and height
 * @param {string} [props.color='currentColor'] stroke and filled-state color
 * @param {boolean} [props.filled=false] whether the heart is filled
 * @param {number|string} [props.strokeWidth=2] SVG stroke width
 * @param {string} [props.ariaLabel] accessible label when the icon conveys meaning
 * @returns {JSX.Element} scalable heart SVG
 */
const IconHeart = props => {
  const {
    className,
    size = 24,
    color = 'currentColor',
    filled = false,
    strokeWidth = 2,
    ariaLabel,
  } = props;
  const accessibilityProps = ariaLabel
    ? { role: 'img', 'aria-label': ariaLabel }
    : { 'aria-hidden': true };

  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={filled ? color : 'none'}
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
      {...accessibilityProps}
    >
      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 0 0 0-7.78Z" />
    </svg>
  );
};

export default IconHeart;
